export const getCategoryId = (id: string) => `${id}_category`;
